import { render, staticRenderFns } from "./ProfessoresTemporarios.vue?vue&type=template&id=22d27652&"
import script from "./ProfessoresTemporarios.vue?vue&type=script&lang=js&"
export * from "./ProfessoresTemporarios.vue?vue&type=script&lang=js&"
import style0 from "./ProfessoresTemporarios.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports